import React, { useState } from 'react';
import { Dimensions, FlatList, Platform, SafeAreaView, StyleSheet, Text, TouchableOpacity, } from 'react-native';
import { luxColors, Iffy, DNABox, DNAText, DNAButton, Icon } from '@alucio/lux-ui';
const width = Dimensions.get('window').width;
const styles = StyleSheet.create({
    container: {
        height: '100vh',
        width: width,
        backgroundColor: luxColors.contentPanelBackground.primary,
    },
    callInButton: {
        width: '90vw',
        marginTop: 8,
        marginBottom: 24,
        fontSize: 18,
    },
    intenationalButton: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
    },
    USNumber: {
        fontSize: 20,
        margin: 8,
    },
    viewIntNums: {
        margin: 8,
        fontSize: 16,
    },
    internationalNumberText: {
        color: luxColors.info.primary,
        fontSize: 15,
        borderBottomColor: luxColors.contentPanelBackground.tertiary,
        borderBottomStartRadius: 1,
    },
    header: {
        marginTop: 12,
        marginBottom: 12,
        borderBottomColor: luxColors.contentPanelBackground.tertiary,
        borderBottomStartRadius: 1,
    },
    subHeader: {
        marginBottom: 20,
        borderBottomColor: luxColors.contentPanelBackground.tertiary,
        borderBottomStartRadius: 1,
    },
    intNumMsg: {
        fontSize: 15,
        opacity: 0.64,
        marginTop: 19,
        borderBottomColor: luxColors.contentPanelBackground.tertiary,
        borderBottomStartRadius: 1,
    },
    icon: {
        width: 32,
        height: 32,
        color: luxColors.primary.primary,
    },
});
function InternationalDialIn(props) {
    const { accessCode, dialInNumbers, onClose } = props;
    const [displayInternationalNumbers, setDisplayInternationalNumbers] = useState(false);
    function onDisplayInternationalNumbers() {
        setDisplayInternationalNumbers((display) => !display);
    }
    function dialNumber(country) {
        const url = `tel:${dialInNumbers[country]},,${accessCode}`;
        if (Platform.OS === 'web') {
            window.open(url, '_blank');
        }
        else {
            window.open(url, '_self');
        }
    }
    const internationalNumbers = () => {
        const data = Object.keys(dialInNumbers).filter((country) => country !== 'US');
        return (React.createElement(SafeAreaView, null,
            React.createElement(FlatList, { style: { maxHeight: '30vh' }, data: data, renderItem: ({ item: country, index: idx }) => (React.createElement(TouchableOpacity, { style: styles.intenationalButton, onPress: () => dialNumber(country) },
                    React.createElement(Text, { key: idx, style: styles.internationalNumberText },
                        dialInNumbers[country],
                        " (",
                        country,
                        ")"),
                    React.createElement(Icon, { name: "phone", style: styles.icon }))), keyExtractor: item => item })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DNABox, { appearance: "col", style: styles.container, alignX: "center", spacing: "around", fill: true },
            React.createElement(DNABox, { appearance: "col", alignX: "center" },
                React.createElement(DNAText, { h4: true, status: "basic", style: styles.header }, "Call-in Instructions"),
                React.createElement(Iffy, { is: displayInternationalNumbers },
                    React.createElement(DNAText, { status: "basic", style: styles.intNumMsg }, "If you don't see your country, choose any."))),
            React.createElement(DNABox, { style: { width: '98vw' }, appearance: "col" },
                React.createElement(DNABox, { appearance: "col", alignX: "center" },
                    React.createElement(DNAText, { h4: true, status: "basic", style: styles.subHeader },
                        "Meeting ID: ",
                        accessCode)),
                React.createElement(Iffy, { is: displayInternationalNumbers }, internationalNumbers()),
                React.createElement(DNABox, { appearance: "col", alignX: "center" },
                    React.createElement(TouchableOpacity, { onPress: () => onDisplayInternationalNumbers() },
                        React.createElement(DNAText, { b2: true, status: "primary", style: styles.viewIntNums },
                            displayInternationalNumbers ? 'Hide' : 'View',
                            "  International Numbers"))),
                React.createElement(DNABox, { appearance: "col", alignX: "center" },
                    React.createElement(DNAText, { status: "basic", style: styles.USNumber },
                        dialInNumbers.US,
                        " (USA)"),
                    React.createElement(DNAButton, { appearance: "filled", status: "primary", context: "round", style: styles.callInButton, onPress: () => dialNumber('US') }, "Call in")))),
        React.createElement(TouchableOpacity, { onLongPress: onClose, style: { position: 'absolute', left: 0, top: 0 } },
            React.createElement(DNABox, { style: { width: 40, height: 40 } }))));
}
export default InternationalDialIn;
//# sourceMappingURL=DNAInternationalNumbers.js.map